const Information = (props) => (
    <div className="articles-information">
        <h2 className="block-title">{props.title}</h2>
        <p className="information-msg">{props.information}</p>
    </div>
)

export default Information